import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 108 108"
      width="1em"
      height="1em"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M54 105.48a51.73 51.73 0 1151.73-51.72A51.78 51.78 0 0154 105.48zM54 10a43.73 43.73 0 1043.72 43.76A43.78 43.78 0 0054 10z"
      />
      <path
        className="prefix__cls-1"
        d="M54 81.79a4 4 0 01-4-4V29.73a4 4 0 118 0v48.06a4 4 0 01-4 4z"
      />
      <path
        className="prefix__cls-1"
        d="M78 57.76H30a4 4 0 110-8h48a4 4 0 010 8z"
      />
    </svg>
  )
}

export default SvgComponent
